import React from 'react';
import { Modal } from 'semantic-ui-react';
import DeleteButton from './DeleteButton';
import CloseButton from './CloseButton';

const DeleteOrCancel = ({
  closeMessageId = 'actions.cancel',
  deleteIcon = 'trash',
  deleteMessageId = 'actions.delete',
  inProgress,
  minimumDataEntryMet,
  onClose,
  onDelete,
}) => (
  <Modal.Actions>
    <CloseButton onClick={onClose} disabled={inProgress} messageId={closeMessageId} />
    <DeleteButton
      icon={deleteIcon}
      inProgress={inProgress}
      messageId={deleteMessageId}
      minimumDataEntryMet={minimumDataEntryMet}
      onClick={onDelete}
    />
  </Modal.Actions>
);

export default DeleteOrCancel;
